import { render } from "./FAQCategoryDialog.vue?vue&type=template&id=13002837"
import script from "./FAQCategoryDialog.vue?vue&type=script&lang=js"
export * from "./FAQCategoryDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__